// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Cache from "../data/Cache.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as HorBarChart from "../common/HorBarChart.bs.js";
import * as Tc2OtherTab from "../tc2/Tc2OtherTab.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as StatsOtherTab from "./StatsOtherTab.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as TraitStatsTables from "../units/TraitStatsTables.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as Tc2RegionDistributionChart from "../tc2/Tc2RegionDistributionChart.bs.js";

function TraitOverview$Overview(Props) {
  var traitStats = Props.traitStats;
  ScreenAtom.use(undefined);
  return React.createElement("div", {
              className: "flex flex-wrap gap-12 p-4"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, "Stats"), React.createElement("div", {
                      className: "grid gap-2 font-montserrat font-medium text-sm leading-none grid-cols-[minmax(auto,85px),auto] grid-rows-[repeat(4,14px)]"
                    }, React.createElement("div", {
                          className: "text-white2"
                        }, "Games:"), React.createElement("div", {
                          className: "font-semibold"
                        }, T.humanReadableCount(traitStats.base.count)), React.createElement("div", {
                          className: "text-white2"
                        }, "Play rate:"), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, traitStats.base.rate)), React.createElement("div", {
                          className: "text-white2"
                        }, "Avg. place: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, traitStats.base.place)), React.createElement("div", {
                          className: "text-white2"
                        }, "Top 4: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(traitStats.base.top4)), React.createElement("div", {
                          className: "text-white2"
                        }, "Win: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(traitStats.base.won)))), React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, "Placement distribution"), React.createElement(HorBarChart.make, {
                      data: Belt_Array.mapWithIndex(traitStats.placeDistribution, (function (idx, count) {
                              return [
                                      String(idx + 1 | 0),
                                      count
                                    ];
                            }))
                    })));
}

var Overview = {
  make: TraitOverview$Overview
};

function TraitOverview$Trends(Props) {
  var traitStats = Props.traitStats;
  var match = React.useState(function () {
        return [
                "All",
                "euw1",
                "na1",
                "kr"
              ];
      });
  var selectedRegions = match[0];
  var t = Translation.useT(/* Common */0);
  var regionDateStats = Belt_Array.keep(traitStats.regionDateStats, (function (dp) {
          return selectedRegions.includes(dp.id[0]);
        }));
  return React.createElement("div", {
              className: "flex flex-col items-center px-5"
            }, React.createElement("div", {
                  className: "flex flex-col md:flex-row pt-4 gap-5"
                }, React.createElement("div", undefined, React.createElement("div", {
                          className: "text-lg leading-none pb-2 font-montserrat font-medium"
                        }, t("Region Distribution")), React.createElement(Tc2RegionDistributionChart.make, {
                          groupPr: traitStats.base.rate,
                          groupPlace: traitStats.base.place,
                          regionDistribution: Belt_Array.map(traitStats.regionStats, (function (dp) {
                                  return [
                                          dp.id,
                                          dp.rate,
                                          dp.place
                                        ];
                                })),
                          selectedRegions: selectedRegions,
                          barWidth: 150
                        })), React.createElement("div", {
                      className: "flex flex-col md:flex-row justify-around pb-3 gap-5"
                    }, React.createElement("div", undefined, React.createElement("div", {
                              className: "text-lg leading-none pl-[28px] pb-2 font-montserrat font-medium"
                            }, t("Play Rate")), React.createElement(StatsOtherTab.DatePlayRateStats.make, {
                              dateStats: traitStats.dateStats,
                              regionDateStats: regionDateStats,
                              selectedRegions: selectedRegions,
                              totCount: traitStats.base.count,
                              chartWidth: 225,
                              chartHeight: 200
                            })), React.createElement("div", {
                          className: "pt-4 sm:pt-0"
                        }, React.createElement("div", {
                              className: "text-lg leading-none pl-[28px] pb-2 font-montserrat font-medium"
                            }, t("Avg. Place")), React.createElement(StatsOtherTab.DatePlaceStats.make, {
                              dateStats: traitStats.dateStats,
                              regionDateStats: regionDateStats,
                              selectedRegions: selectedRegions,
                              chartWidth: 225,
                              chartHeight: 200
                            })))), React.createElement("div", {
                  className: "py-2"
                }, React.createElement(Tc2OtherTab.RegionSelect.make, {
                      selectedRegions: selectedRegions,
                      setSelectedRegions: match[1]
                    })));
}

var Trends = {
  make: TraitOverview$Trends
};

function TraitOverview$Counters(Props) {
  var traitStats = Props.traitStats;
  var inContext = Props.inContext;
  var screenSize = ScreenAtom.use(undefined);
  var avgWr = Belt_Array.reduce(traitStats.unitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / traitStats.unitMatchups.length;
  var avgWr$1 = Belt_Array.reduce(traitStats.traitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / traitStats.traitMatchups.length;
  var avgWr$2 = Belt_Array.reduce(traitStats.unitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / traitStats.unitMatchups.length;
  var avgWr$3 = Belt_Array.reduce(traitStats.traitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / traitStats.traitMatchups.length;
  return React.createElement("div", {
              className: "sm:flex"
            }, React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "flex-1",
                  title: "Strong Against",
                  children: null
                }, React.createElement("h6", {
                      className: "text-lg pb-3 pt-1 font-medium"
                    }, "Units"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getBestMatchups(traitStats.unitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr), (function (m) {
                            return React.createElement(UnitImage.make, {
                                        unitId: m.unitId,
                                        size: 42,
                                        sizeMd: 52,
                                        key: m.unitId
                                      });
                          }))), React.createElement("h6", {
                      className: "text-lg pb-2 pt-8 font-medium"
                    }, "Traits"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getBestMatchups(traitStats.traitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$1), (function (m) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: m.traitId,
                                        rank: m.traitTier,
                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                              traitId: m.traitId,
                                              rank: m.traitTier,
                                              size: 40,
                                              sizeMd: 50,
                                              key: m.traitId + String(m.traitTier)
                                            })
                                      });
                          })))), React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "flex-1 mt-4 sm:mt-0 sm:ml-4",
                  title: "Weak Against",
                  children: null
                }, React.createElement("h6", {
                      className: "text-lg pb-3 pt-1 font-medium"
                    }, "Units"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getWorstMatchups(traitStats.unitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$2), (function (m) {
                            return React.createElement(UnitImage.make, {
                                        unitId: m.unitId,
                                        size: 42,
                                        sizeMd: 52,
                                        key: m.unitId
                                      });
                          }))), React.createElement("h6", {
                      className: "text-lg pb-2 pt-8 font-medium"
                    }, "Traits"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getWorstMatchups(traitStats.traitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$3), (function (m) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: m.traitId,
                                        rank: m.traitTier,
                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                              traitId: m.traitId,
                                              rank: m.traitTier,
                                              size: 40,
                                              sizeMd: 50
                                            })
                                      });
                          })))));
}

var Counters = {
  make: TraitOverview$Counters
};

function TraitOverview$Inner(Props) {
  var inContextOpt = Props.inContext;
  var traitStats = Props.traitStats;
  var scrollRef = Props.scrollRef;
  var inContext = inContextOpt !== undefined ? inContextOpt : false;
  ScreenAtom.use(undefined);
  ApertureCtx.useValue(undefined);
  var match = React.useState(function () {
        return /* Overview */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var tmp = {
    inContext: inContext,
    traitStats: traitStats
  };
  if (scrollRef !== undefined) {
    tmp.scrollRef = Caml_option.valFromOption(scrollRef);
  }
  return React.createElement("div", {
              className: "grid gap-4"
            }, React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "text-sm sm:text-base",
                  children: null,
                  noPadding: true
                }, React.createElement("div", {
                      className: "flex justify-start pt-2 max-w-screen"
                    }, React.createElement(Tabs, {
                          children: null,
                          value: tab,
                          onChange: (function (param, t) {
                              return Curry._1(setTab, (function (param) {
                                            return t;
                                          }));
                            })
                        }, React.createElement(Tab, {
                              label: "Overview",
                              value: /* Overview */0
                            }), React.createElement(Tab, {
                              label: "Trends",
                              value: /* Trends */1
                            }))), tab ? React.createElement(TraitOverview$Trends, {
                        traitStats: traitStats
                      }) : React.createElement(TraitOverview$Overview, {
                        traitStats: traitStats
                      })), React.createElement(TraitStatsTables.make, tmp), traitStats.unitMatchups.length === 0 && traitStats.traitMatchups.length === 0 ? null : React.createElement(TraitOverview$Counters, {
                    traitStats: traitStats,
                    inContext: inContext
                  }));
}

var Inner = {
  make: TraitOverview$Inner
};

function TraitOverview(Props) {
  var inContext = Props.inContext;
  var traitId = Props.traitId;
  var rank = Props.rank;
  var scrollRef = Props.scrollRef;
  var aperture = ApertureCtx.useValue(undefined);
  var traitStats = Cache.useTraitStats2(traitId, rank, aperture.queue);
  if (traitStats === undefined) {
    return null;
  }
  var tmp = {
    traitStats: traitStats
  };
  if (inContext !== undefined) {
    tmp.inContext = Caml_option.valFromOption(inContext);
  }
  if (scrollRef !== undefined) {
    tmp.scrollRef = Caml_option.valFromOption(scrollRef);
  }
  return React.createElement(TraitOverview$Inner, tmp);
}

var make = TraitOverview;

export {
  Overview ,
  Trends ,
  Counters ,
  Inner ,
  make ,
  
}
/* T Not a pure module */
